import { useI18n } from '@oneaudi/i18n-context';
import { Headline, Layout, Text, TextButton } from '@oneaudi/unified-web-components';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { messages } from '../../i18n/messages';
import { DealerContext } from '../../context';

interface DealerSearchIntroProps {
  handleSetShowDealerSearch: () => void;
}

const StyledLayout = styled(Layout)`
  width: auto;
  padding: var(--spacing-relative-lg) var(--spacing-relative-3xl) var(--spacing-relative-lg)
    var(--spacing-relative-3xl);

  @media (min-width: 1440px) {
    padding: var(--spacing-relative-lg);
  }
`;

const DealerSearchIntro: React.FC<DealerSearchIntroProps> = ({ handleSetShowDealerSearch }) => {
  const { setDealerConnectedNotification } = useContext(DealerContext);
  const heading = useI18n(messages.dealership_connect_heading);
  const body = useI18n(messages.dealership_connect_body);
  const buttonText = useI18n(messages.dealership_connect_button);

  return (
    <StyledLayout
      align="flex-start"
      columnGap="24px"
      direction="column"
      justify="flex-start"
      rowGap="var(--spacing-relative-lg)"
    >
      <Headline
        variant={{
          order: '4',
          type: 'headline',
          weight: 'normal',
        }}
        tag="h2"
      >
        {heading}
      </Headline>
      <Text>
        <span
          dangerouslySetInnerHTML={{
            __html: body,
          }}
        />
      </Text>
      <TextButton
        id="find-a-dealer-button"
        aria-label={buttonText}
        iconPosition="leading"
        icon="poi"
        onClick={() => {
          handleSetShowDealerSearch();
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-expect-error
          setDealerConnectedNotification((prev) => ({
            ...prev,
            dealerSearchBenefitSelected: true,
          }));
        }}
        size="md"
        title={buttonText}
        variant="secondary"
      >
        {buttonText}
      </TextButton>
    </StyledLayout>
  );
};

export default DealerSearchIntro;
